import { Animation } from "@babylonjs/core/Animations/animation";
export function createAnimationState() {
    return {
        key: 0,
        repeatCount: 0,
        loopMode: Animation.ANIMATIONLOOPMODE_CONSTANT
    };
}
